export default __webpack_public_path__ + "static/test_3_2_ru-a2cd70d7cd86f46690de04fcc7333bbd.png";